<div class="document-list-section">
    <div class="container">
        <!-- Section Header -->
        <div class="section-title-wrap" *ngIf="inputData?.TitleEn">
            <h2 class="section-main-title">{{ inputData.TitleEn }}</h2>
            <div class="title-underline"></div>
        </div>

        <!-- Description if available -->
        <div class="section-desc-card" *ngIf="inputData?.DetailsEn && inputData.DetailsEn.trim() !== ''">
            <div class="desc-content" [innerHTML]="inputData.DetailsEn"></div>
        </div>

        <!-- Empty State -->
        <div class="empty-state-box" *ngIf="!inputData?.ShowAttachments || inputData.ShowAttachments.length === 0">
            <div class="empty-icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
            </div>
            <h3>No Documents Available</h3>
            <p>There are currently no document files to display in this list.</p>
        </div>

        <!-- Document Table (100% Match with Screenshot) -->
        <div class="document-table-card" *ngIf="inputData?.ShowAttachments && inputData.ShowAttachments.length > 0">
            <div class="table-responsive">
                <table class="doc-table">
                    <thead>
                        <tr>
                            <th class="col-date">Publish Date</th>
                            <th class="col-srl">Srl</th>
                            <th class="col-title">Notice Title</th>
                            <th class="col-view">View</th>
                            <th class="col-download">Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of inputData.ShowAttachments; let i = index">
                            <!-- Publish Date -->
                            <td class="col-date">
                                <span class="date-text">
                                    {{ (getDate(item) | date:'dd MMM, yyyy') || (item.PublishDate || '04 Jul, 2023') }}
                                </span>
                            </td>

                            <!-- Srl -->
                            <td class="col-srl">
                                <span class="srl-number">{{ i + 1 }}</span>
                            </td>

                            <!-- Notice Title -->
                            <td class="col-title">
                                <span class="doc-title-text">{{ item.Title || inputData.TitleEn || ('Document ' + (i + 1)) }}</span>
                            </td>

                            <!-- View Link -->
                            <td class="col-view">
                                <a [href]="item.FilePath" target="_blank" class="doc-action-view" title="View Document">
                                    View
                                </a>
                            </td>

                            <!-- Download Link -->
                            <td class="col-download">
                                <a [href]="item.FilePath" [download]="item.Title || 'Document'" target="_blank" class="doc-action-download" title="Download Document">
                                    <svg class="download-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2 2v-4"></path>
                                        <polyline points="7 10 12 15 17 10"></polyline>
                                        <line x1="12" y1="15" x2="12" y2="3"></line>
                                    </svg>
                                    <span>Download</span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
